import { Card, CardContent, CardHeader, CardTitle } from "@jourfx/ui";
import { useTranslation } from "react-i18next";

import { getBuildInfo } from "@/lib/buildInfo";

export function BuildInfoCard() {
  const { t } = useTranslation("settings");
  const buildInfo = getBuildInfo();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("build.title")}</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-3 text-sm sm:grid-cols-2">
        <div>
          <p className="text-muted-foreground">{t("build.version")}</p>
          <p className="font-medium">{buildInfo.appVersion}</p>
        </div>
        <div>
          <p className="text-muted-foreground">{t("build.buildId")}</p>
          <p className="font-medium break-all">{buildInfo.buildId}</p>
        </div>
        <div>
          <p className="text-muted-foreground">{t("build.gitSha")}</p>
          <p className="font-medium">{buildInfo.shortSha}</p>
        </div>
        <div>
          <p className="text-muted-foreground">{t("build.builtAt")}</p>
          <p className="font-medium">{buildInfo.builtAt}</p>
        </div>
      </CardContent>
    </Card>
  );
}
